/* Sauna comparison: selection (localStorage), collection-card toggles, product-page link,
   floating tray, and the /pages/compare table. Markup: snippets/mk-compare-*.liquid, sections/mk-compare.liquid */
(function () {
  if (window.MkCompare) return;
  var MAX = 4;
  var KEY = 'mk_compare';

  // ---------- selection ----------
  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.filter(function (x) { return x && x.handle; }).slice(0, MAX) : []; }
    catch (e) { return []; }
  }
  var items = load(); // [{handle, title, image}]
  function save(silent) { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} if (!silent) emit(); }
  function has(h) { return items.some(function (x) { return x.handle === h; }); }
  function add(item) {
    if (has(item.handle)) return true;
    if (items.length >= MAX) { emit('full'); return false; }
    items.push(item); save(); track('compare_add', item.handle); return true;
  }
  function remove(h) { items = items.filter(function (x) { return x.handle !== h; }); save(); }
  function setAll(list, silent) { items = list.slice(0, MAX); save(silent); }
  function emit(reason) { document.dispatchEvent(new CustomEvent('mk:compare', { detail: { items: items, reason: reason } })); }
  function track(event, handle) { (window.dataLayer = window.dataLayer || []).push({ event: event, product_handle: handle || '', compare_count: items.length }); }

  function root() { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  // TODO before go-live: remove the preview branch. /pages/compare doesn't exist yet, so preview themes
  // render the compare template on an existing page via ?view=compare.
  function compareUrl(handles) {
    var p = new URLSearchParams();
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    var page = 'compare';
    if (role && role !== 'main') { page = 'contact-lead-gen'; p.set('view', 'compare'); }
    if (handles && handles.length) p.set('models', handles.join(','));
    var q = p.toString().replace(/%2C/g, ',');
    return root() + 'pages/' + page + (q ? '?' + q : '');
  }
  function itemFrom(el) { return { handle: el.getAttribute('data-handle'), title: el.getAttribute('data-title') || '', image: el.getAttribute('data-image') || '' }; }

  // ---------- collection cards + product link ----------
  function syncToggles() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cmp-toggle]'), function (input) {
      input.checked = has(input.getAttribute('data-handle'));
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target.closest && e.target.closest('[data-cmp-toggle]');
    if (!t) return;
    if (t.checked) { if (!add(itemFrom(t))) t.checked = false; }
    else remove(t.getAttribute('data-handle'));
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cmp-link]');
    if (!a) return;
    e.preventDefault();
    var me = itemFrom(a);
    // Open the comparison with this sauna first, keeping anything already chosen.
    var list = [me].concat(items.filter(function (x) { return x.handle !== me.handle; })).slice(0, MAX);
    setAll(list, true); // silent: we're leaving the page, so don't flash the tray first
    track('compare_link_click', me.handle);
    location.href = compareUrl(list.map(function (x) { return x.handle; }));
  });

  // ---------- floating tray ----------
  function renderTray(reason) {
    var tray = document.getElementById('mk-cmp-tray');
    if (!tray || document.getElementById('mk-cmp')) return;
    tray.hidden = items.length === 0;
    document.documentElement.classList.toggle('mk-cmp-has-tray', items.length > 0);
    if (!items.length) return;
    var thumbs = '';
    for (var i = 0; i < MAX; i++) {
      var it = items[i];
      thumbs += it
        ? '<li class="mk-cmp-tray__item"><img src="' + esc(it.image) + '" alt="" width="56" height="42" loading="lazy"><span class="mk-cmp-tray__name">' + esc(it.title) + '</span>' +
          '<button type="button" class="mk-cmp-tray__x" data-cmp-remove="' + esc(it.handle) + '" aria-label="Remove ' + esc(it.title) + '">&times;</button></li>'
        : '<li class="mk-cmp-tray__item is-empty" aria-hidden="true"></li>';
    }
    tray.querySelector('[data-cmp-tray-list]').innerHTML = thumbs;
    var go = tray.querySelector('[data-cmp-tray-go]');
    go.href = compareUrl(items.map(function (x) { return x.handle; }));
    go.textContent = items.length > 1 ? 'Compare ' + items.length + ' saunas' : 'Compare';
    go.classList.toggle('is-disabled', items.length < 2);
    go.setAttribute('aria-disabled', items.length < 2 ? 'true' : 'false');
    var msg = tray.querySelector('[data-cmp-tray-msg]');
    msg.textContent = reason === 'full' ? 'You can compare up to ' + MAX + ' saunas. Remove one to add another.'
      : items.length < 2 ? 'Add one more sauna to compare.' : '';
  }
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-cmp-remove]');
    if (x && !document.getElementById('mk-cmp')) { remove(x.getAttribute('data-cmp-remove')); return; }
    if (e.target.closest && e.target.closest('[data-cmp-clear]')) { setAll([]); return; }
    var go = e.target.closest && e.target.closest('[data-cmp-tray-go]');
    if (go && go.classList.contains('is-disabled')) e.preventDefault();
  });
  document.addEventListener('mk:compare', function (e) { syncToggles(); renderTray(e.detail.reason); });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // ---------- comparison page ----------
  function initPage(rootEl) {
    var specs, products;
    try {
      specs = JSON.parse(document.getElementById('mk-cmp-specs').textContent);
      products = JSON.parse(document.getElementById('mk-cmp-products').textContent);
    } catch (e) { return; }
    var ALL = products.filter(function (p) { return specs[p.handle]; }).map(function (p) {
      var s = specs[p.handle];
      return { handle: p.handle, title: p.title, url: p.url, price: p.price, priceNum: p.priceNum, image: p.image, brand: s.brand, name: s.name, sizes: s.sizes, specs: s };
    });
    var byHandle = {}; ALL.forEach(function (s) { byHandle[s.handle] = s; });
    var sizeSel = {};
    var grid = rootEl.querySelector('[data-cmp-grid]');
    var mini = rootEl.querySelector('[data-cmp-mini]');
    var bar = rootEl.querySelector('[data-cmp-bar]');

    var fromUrl = (new URLSearchParams(location.search).get('models') || '').split(',').filter(function (h) { return byHandle[h]; });
    var sel = (fromUrl.length ? fromUrl : items.map(function (x) { return x.handle; }).filter(function (h) { return byHandle[h]; })).slice(0, MAX);

    function persist() {
      setAll(sel.map(function (h) { var s = byHandle[h]; return { handle: h, title: s.title, image: s.image }; }));
      var p = new URLSearchParams(location.search);
      if (sel.length) p.set('models', sel.join(',')); else p.delete('models');
      var q = p.toString().replace(/%2C/g, ',');
      history.replaceState(null, '', location.pathname + (q ? '?' + q : ''));
    }

    // ----- formatting -----
    var ASK = '<span class="mk-cmp__ask">Ask us</span>';
    function size(s) { return s.sizes[sizeSel[s.handle] || 0] || {}; }
    function capText(c) { return !c ? null : c[0] === c[1] ? String(c[0]) : c[0] + '–' + c[1]; }
    function ft(n) { var f = Math.floor(n / 12), i = Math.round(n % 12); if (i === 12) { f++; i = 0; } return i ? f + '′' + i + '″' : f + '′'; }
    // Units and the "Will it fit?" space are remembered per visitor. Specs are stored in inches.
    var PREFS = 'mk_compare_prefs';
    var prefs = (function () { try { return JSON.parse(localStorage.getItem(PREFS) || '{}') || {}; } catch (e) { return {}; } })();
    var unit = prefs.unit === 'cm' ? 'cm' : 'in';
    var space = { w: +prefs.w || 0, d: +prefs.d || 0 }; // inches
    function savePrefs() { try { localStorage.setItem(PREFS, JSON.stringify({ unit: unit, w: space.w, d: space.d })); } catch (e) {} }
    function len(n) { return unit === 'cm' ? Math.round(n * 2.54) + ' cm' : n + '″'; }
    // Several lengths with the unit written once: 302 × 224 × 302 cm / 119″ × 88″ × 119″
    function dimsText(a) { return unit === 'cm' ? a.map(function (n) { return Math.round(n * 2.54); }).join(' × ') + ' cm' : a.map(function (n) { return n + '″'; }).join(' × '); }
    function lenSub(n) { return unit === 'cm' ? (n * .0254).toFixed(2) + ' m' : ft(n); }
    function fromInput(v) { v = parseFloat(v); return v > 0 ? (unit === 'cm' ? v / 2.54 : v) : 0; }
    function toInput(n) { return n ? String(unit === 'cm' ? Math.round(n * 2.54) : Math.round(n * 10) / 10) : ''; }
    // Text spec, or "Ask us" when the sheets don't state it (null). The key keeps unknowns from matching each other.
    function txt(s, v) { return v == null ? [ASK, '?' + s.handle] : [esc(v), v]; }
    function incl(v) { return v === 'Yes' ? '<span class="mk-cmp__yes">Included</span>' : v === 'Optional' ? 'Optional add-on' : v === 'No' ? '<span class="mk-cmp__no">—</span>' : ASK; }

    // [label, fn(sauna) -> [html, compareKey]]
    var ROWS = [
      ['Size & capacity', [
        ['Capacity', function (s) { var c = capText(size(s).cap); return c ? [c + (c === '1' ? ' person' : ' people'), c] : [ASK, '?' + s.handle]; }],
        ['Exterior (W × D × H)', function (s) {
          var z = size(s);
          if (z.w && z.d && z.h) return [dimsText([z.w, z.d, z.h]) + '<span class="mk-cmp__sub">' + lenSub(z.w) + ' × ' + lenSub(z.d) + ' × ' + lenSub(z.h) + '</span>', [z.w, z.d, z.h].join()];
          if (z.w && z.d) return [dimsText([z.w, z.d]) + '<span class="mk-cmp__sub">Height on request</span>', [z.w, z.d].join()];
          if (z.d) return [len(z.d) + ' long<span class="mk-cmp__sub">Full dimensions on request</span>', '?' + s.handle];
          return [ASK, '?' + s.handle];
        }],
        ['Footprint', function (s) {
          var z = size(s); if (!z.w || !z.d) return [ASK, '?' + s.handle];
          var sq = (z.w * z.d / 144).toFixed(1);
          return [unit === 'cm' ? (z.w * z.d * .00064516).toFixed(2) + ' m²' : sq + ' sq ft', sq];
        }]
      ]],
      ['Heat & air', [
        ['Heat source', function (s) { return [s.specs.heat.map(function (h) { return '<span class="mk-cmp__chip">' + esc(h) + '</span>'; }).join(''), s.specs.heat.join()]; }],
        ['Pre-wired electrical panel', function (s) { return [incl(s.specs.panel), s.specs.panel]; }],
        ['Ventilation', function (s) { return txt(s, s.specs.ventilation); }]
      ]],
      ['Build', [
        ['Use', function (s) { return txt(s, s.specs.placement); }],
        ['Assembly', function (s) { return txt(s, s.specs.assembly); }],
        ['Wood', function (s) { return txt(s, s.specs.materials); }],
        ['Insulation', function (s) { var v = s.specs.insulation; if (v == null) return txt(s, v); return [v === 'None' ? '<span class="mk-cmp__no">—</span>' : v === 'Yes' ? '<span class="mk-cmp__yes">Insulated</span>' : esc(v), v]; }]
      ]],
      ['Comfort & finish', [
        ['Lighting', function (s) { return [incl(s.specs.lighting), s.specs.lighting]; }],
        ['Audio', function (s) { return [incl(s.specs.audio), s.specs.audio]; }],
        ['Exterior colour', function (s) { var c = s.specs.color; if (c == null) return txt(s, c); return [c === 'Yes' ? 'Custom colours available' : esc(c), c]; }]
      ]]
    ];

    // Fits in either orientation. Exterior size only: clearance around the sauna is confirmed on the quote.
    function fitCell(s) {
      var z = size(s);
      if (!z.w || !z.d) return [ASK, '?' + s.handle];
      var a = [space.w - z.w, space.d - z.d], b = [space.w - z.d, space.d - z.w];
      var ok = function (m) { return m[0] >= 0 && m[1] >= 0; };
      if (ok(a) || ok(b)) {
        var m = ok(a) && ok(b) ? (Math.min(a[0], a[1]) >= Math.min(b[0], b[1]) ? a : b) : ok(a) ? a : b;
        var spare = Math.round(Math.min(m[0], m[1]));
        return ['<span class="mk-cmp__yes">Fits</span><span class="mk-cmp__sub">' + (spare > 0 ? len(spare) + ' to spare on the tightest side' : 'Exact fit, no room to spare') + '</span>', 'fit'];
      }
      return ['<span class="mk-cmp__nofit">Too big</span><span class="mk-cmp__sub">Needs ' + dimsText([z.w, z.d]) + '</span>', 'nofit'];
    }

    function render() {
      var list = sel.map(function (h) { return byHandle[h]; });
      var showAdd = list.length < MAX;
      // With a single sauna (e.g. arriving from its product page), fill the free columns with similar models.
      var sugg = list.length === 1 ? ALL.filter(function (s) { return s.handle !== list[0].handle; })
        .sort(function (a, b) { return similarity(list[0], b) - similarity(list[0], a); }).slice(0, MAX - 2) : [];
      var cols = Math.min(MAX, Math.max(list.length + sugg.length + (showAdd ? 1 : 0), 2));
      rootEl.style.setProperty('--cmp-cols', cols);
      var pad = cols - list.length - sugg.length - (showAdd ? 1 : 0);
      var emptyCell = '<div class="mk-cmp__cell is-filler"></div>';

      var h = '<div class="mk-cmp__cell mk-cmp__head mk-cmp__label">' + list.length + ' of ' + MAX + ' selected</div>';
      list.forEach(function (s) {
        var sizes = s.sizes.length > 1 ? '<select class="mk-cmp__size" data-cmp-size="' + s.handle + '" aria-label="Size of ' + esc(s.name) + '">' +
          s.sizes.map(function (z, i) { return '<option value="' + i + '"' + (i === (sizeSel[s.handle] || 0) ? ' selected' : '') + '>' + esc(z.label) + (z.cap ? ' · up to ' + z.cap[1] + ' people' : '') + '</option>'; }).join('') + '</select>' : '';
        h += '<div class="mk-cmp__cell mk-cmp__head mk-cmp__card">' +
          '<button type="button" class="mk-cmp__remove" data-cmp-del="' + s.handle + '" aria-label="Remove ' + esc(s.name) + '">&times;</button>' +
          '<a class="mk-cmp__img" href="' + s.url + '"><img src="' + esc(s.image) + '" alt="' + esc(s.title) + '" loading="lazy" width="800" height="600"></a>' +
          '<p class="mk-cmp__brand">' + esc(s.brand) + '</p><h3 class="mk-cmp__name"><a href="' + s.url + '">' + esc(s.name) + '</a></h3>' +
          '<p class="mk-cmp__price"><span>From</span> ' + esc(s.price) + '</p>' + sizes +
          '<a class="mk-cmp__view" href="' + s.url + '">View sauna</a></div>';
      });
      sugg.forEach(function (s) {
        h += '<div class="mk-cmp__cell mk-cmp__head mk-cmp__sugg" role="button" tabindex="0" data-cmp-pick="' + s.handle + '" aria-label="Add ' + esc(s.title) + ' to the comparison">' +
          '<span class="mk-cmp__sugg-tag">Similar</span>' +
          '<span class="mk-cmp__img"><img src="' + esc(s.image) + '" alt="" loading="lazy" width="800" height="600"></span>' +
          '<p class="mk-cmp__brand">' + esc(s.brand) + '</p><p class="mk-cmp__name">' + esc(s.name) + '</p>' +
          '<p class="mk-cmp__price"><span>From</span> ' + esc(s.price) + '</p>' +
          '<span class="mk-cmp__view mk-cmp__sugg-add">+ Add to compare</span></div>';
      });
      if (showAdd) h += '<div class="mk-cmp__cell mk-cmp__head"><button type="button" class="mk-cmp__add" data-cmp-open><span class="mk-cmp__plus" aria-hidden="true">+</span>Add a sauna</button></div>';
      for (var i = 0; i < pad; i++) h += '<div class="mk-cmp__cell mk-cmp__head is-filler"></div>';

      var groups = ROWS;
      if (space.w && space.d) {
        groups = ROWS.slice();
        groups[0] = [ROWS[0][0], [['Fits your space<span class="mk-cmp__sub">' + dimsText([Math.round(space.w), Math.round(space.d)]) + ', exterior only</span>', fitCell]].concat(ROWS[0][1])];
      }
      if (list.length) {
        groups.forEach(function (g) {
          h += '<div class="mk-cmp__group"><span>' + g[0] + '</span></div>';
          g[1].forEach(function (r) {
            var vals = list.map(r[1]);
            var same = list.length > 1 && vals.every(function (v) { return v[1] === vals[0][1]; });
            var cls = list.length > 1 ? (same ? 'is-same' : 'is-diff') : '';
            h += '<div class="mk-cmp__row ' + cls + '"><div class="mk-cmp__cell mk-cmp__label"><span>' + r[0] + '</span></div>' +
              vals.map(function (v) { return '<div class="mk-cmp__cell mk-cmp__val">' + v[0] + '</div>'; }).join('') +
              new Array(sugg.length + (showAdd ? 1 : 0) + pad + 1).join(emptyCell) + '</div>';
          });
        });
      }
      grid.innerHTML = h;
      var addTop = rootEl.querySelector('[data-cmp-add-top]');
      if (addTop) addTop.hidden = !showAdd;
      mini.innerHTML = '<div></div>' + list.map(function (s) { return '<div><small>' + esc(s.brand) + '</small>' + esc(s.name) + '</div>'; }).join('');

      var narrow = matchMedia('(max-width: 749px)').matches;
      rootEl.querySelector('[data-cmp-note]').textContent = list.length < 2 ? 'Add at least two saunas to compare.'
        : narrow && list.length > 2 ? 'Swipe the table to see all ' + list.length + ' saunas →' : '';
      var names = list.map(function (s) { return s.name; });
      var ctaText = rootEl.querySelector('[data-cmp-cta-text]');
      if (!ctaText.getAttribute('data-default')) ctaText.setAttribute('data-default', ctaText.textContent);
      ctaText.textContent = names.length ? 'Talk to a sauna specialist about the ' + names.join(', ').replace(/, ([^,]*)$/, ' and $1') + '.' : ctaText.getAttribute('data-default');
      persist();
      stick();
    }

    // ----- picker -----
    var FILTERS = {
      use: { opts: ['Outdoor', 'Indoor'], test: function (s, v) { return s.specs.placement === v; } },
      people: { opts: ['1–2', '3–4', '5–6', '7+'], test: function (s, v) {
        var m = maxCap(s);
        return v === '1–2' ? m <= 2 : v === '3–4' ? m >= 3 && m <= 4 : v === '5–6' ? m >= 5 && m <= 6 : m >= 7; } },
      heat: { opts: ['Electric', 'Wood', 'Infrared'], test: function (s, v) { return s.specs.heat.indexOf(v) > -1; } },
      build: { opts: ['Pre-assembled', 'Built on site'], test: function (s, v) { return s.specs.assembly === v; } }
    };
    var active = {};
    var picker = rootEl.querySelector('[data-cmp-picker]');
    var q = rootEl.querySelector('[data-cmp-q]');
    var listEl = rootEl.querySelector('[data-cmp-list]');
    var filtersEl = rootEl.querySelector('[data-cmp-filters]');
    filtersEl.innerHTML = Object.keys(FILTERS).map(function (k) {
      return '<div class="mk-cmp-picker__fgroup">' + FILTERS[k].opts.map(function (o) { return '<button type="button" data-cmp-f="' + k + '" data-v="' + o + '" aria-pressed="false">' + o + '</button>'; }).join('') + '</div>';
    }).join('');

    function maxCap(s) { return Math.max.apply(null, s.sizes.map(function (z) { return z.cap ? z.cap[1] : 0; }).concat(0)); }
    // Same use, close capacity, shared heat source, similar price: what a shopper would put next to it.
    function similarity(a, b) {
      var score = 0;
      if (a.specs.placement === b.specs.placement) score += 3;
      score -= Math.abs(maxCap(a) - maxCap(b));
      if (a.specs.heat.some(function (x) { return b.specs.heat.indexOf(x) > -1; })) score += 1;
      if (a.brand === b.brand) score += 1;
      score -= Math.abs(Math.log(a.priceNum / b.priceNum)) * 2;
      return score;
    }
    function renderList() {
      var term = q.value.trim().toLowerCase();
      var res = ALL.filter(function (s) {
        return (!term || (s.brand + ' ' + s.name + ' ' + s.title).toLowerCase().indexOf(term) > -1) &&
          Object.keys(active).every(function (k) { return !active[k] || FILTERS[k].test(s, active[k]); });
      });
      var anchor = byHandle[sel[0]];
      var suggesting = anchor && !term && !Object.keys(active).some(function (k) { return active[k]; });
      if (suggesting) res = res.filter(function (s) { return sel.indexOf(s.handle) < 0; }).sort(function (a, b) { return similarity(anchor, b) - similarity(anchor, a); });
      else res.sort(function (a, b) { return a.brand === b.brand ? a.priceNum - b.priceNum : a.brand < b.brand ? -1 : 1; });
      rootEl.querySelector('[data-cmp-suggest]').hidden = !suggesting;
      listEl.innerHTML = res.length ? res.map(function (s) {
        var on = sel.indexOf(s.handle) > -1, m = maxCap(s);
        // Not a <button>: the theme forces height and layout on every button.
        return '<div class="mk-cmp-pick' + (on ? ' is-added' : '') + '" role="button" tabindex="' + (on ? '-1' : '0') + '" data-cmp-pick="' + s.handle + '" aria-disabled="' + on + '">' +
          '<span class="mk-cmp-pick__img"><img src="' + esc(s.image) + '" alt="" loading="lazy" width="400" height="300"></span>' +
          '<span class="mk-cmp-pick__brand">' + esc(s.brand) + '</span><span class="mk-cmp-pick__name">' + esc(s.name) + '</span>' +
          '<span class="mk-cmp-pick__meta">' + esc(s.specs.placement) + (m ? ' · up to ' + m : '') + ' · ' + esc(s.price) + (on ? ' · Added' : '') + '</span></div>';
      }).join('') : '<p class="mk-cmp-picker__none">No saunas match these filters.</p>';
    }
    var lastFocus;
    function openPicker() {
      lastFocus = document.activeElement; picker.hidden = false; document.documentElement.classList.add('mk-cmp-lock');
      requestAnimationFrame(function () { picker.classList.add('is-open'); });
      renderList(); setTimeout(function () { q.focus(); }, 60);
    }
    function closePicker() {
      picker.classList.remove('is-open'); document.documentElement.classList.remove('mk-cmp-lock');
      setTimeout(function () { picker.hidden = true; }, 300); if (lastFocus) lastFocus.focus();
    }

    // ----- events -----
    rootEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cmp-open],[data-cmp-del],[data-cmp-pick],[data-cmp-close],[data-cmp-f],[data-cmp-share]');
      if (!t) return;
      if (t.hasAttribute('data-cmp-open')) openPicker();
      else if (t.hasAttribute('data-cmp-del')) { var d = t.getAttribute('data-cmp-del'); sel = sel.filter(function (h) { return h !== d; }); render(); }
      else if (t.hasAttribute('data-cmp-pick')) {
        if (t.getAttribute('aria-disabled') === 'true' || sel.indexOf(t.getAttribute('data-cmp-pick')) > -1) return;
        sel.push(t.getAttribute('data-cmp-pick')); track('compare_add', t.getAttribute('data-cmp-pick')); render();
        if (sel.length >= MAX) closePicker(); else renderList();
      }
      else if (t.hasAttribute('data-cmp-close')) closePicker();
      else if (t.hasAttribute('data-cmp-f')) {
        var k = t.getAttribute('data-cmp-f'), v = t.getAttribute('data-v');
        active[k] = active[k] === v ? null : v;
        Array.prototype.forEach.call(filtersEl.querySelectorAll('[data-cmp-f="' + k + '"]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === active[k])); });
        renderList();
      }
      else if (t.hasAttribute('data-cmp-share')) {
        var done = function (txt) { t.textContent = txt; setTimeout(function () { t.textContent = 'Copy link'; }, 2000); };
        if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(function () { done('Link copied'); }, function () { done('Copy the address bar'); });
        else done('Copy the address bar');
        track('compare_share');
      }
    });
    rootEl.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-cmp-size')) { sizeSel[e.target.getAttribute('data-cmp-size')] = +e.target.value; render(); }
      if (e.target.hasAttribute('data-cmp-same')) rootEl.classList.toggle('hide-same', e.target.checked);
      if (e.target.hasAttribute('data-cmp-unit')) { unit = e.target.value; syncPrefsUi(); savePrefs(); render(); track('compare_units', unit); }
    });
    q.addEventListener('input', renderList);
    var fitTimer;
    rootEl.addEventListener('input', function (e) {
      var k = e.target.getAttribute && e.target.getAttribute('data-cmp-space');
      if (!k) return;
      space[k] = fromInput(e.target.value); savePrefs(); render();
      clearTimeout(fitTimer);
      fitTimer = setTimeout(function () { if (space.w && space.d) track('compare_fit_check'); }, 1500);
    });
    function syncPrefsUi() {
      Array.prototype.forEach.call(rootEl.querySelectorAll('[data-cmp-unit]'), function (r) { r.checked = r.value === unit; });
      Array.prototype.forEach.call(rootEl.querySelectorAll('[data-cmp-space]'), function (i) { i.value = toInput(space[i.getAttribute('data-cmp-space')]); });
      rootEl.querySelector('[data-cmp-unit-label]').textContent = unit;
    }
    syncPrefsUi();
    rootEl.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.hasAttribute('data-cmp-pick')) { e.preventDefault(); e.target.click(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !picker.hidden) closePicker(); });

    // The quote form opens with the compared models written in its message box (mk-form sends it to HubSpot).
    rootEl.querySelector('[data-cmp-quote]').addEventListener('click', function () {
      track('compare_quote_click');
      var box = document.querySelector('#mk-quote-dialog textarea[name="message"]');
      if (!box || !sel.length) return;
      var line = 'Comparing: ' + sel.map(function (h) { return byHandle[h].title; }).join(', ');
      if (!box.value || /^Comparing: /.test(box.value)) box.value = line;
    });

    // Compact name bar once the product cards scroll away.
    function stick() {
      var ref = grid.querySelector('.mk-cmp__view') || grid.querySelector('.mk-cmp__head');
      // The bar sits under the theme's sticky header, so compare against its own position, not the viewport top.
      var row = bar.firstElementChild;
      if (ref) bar.classList.toggle('is-stuck', ref.getBoundingClientRect().bottom < bar.getBoundingClientRect().top + row.offsetHeight);
    }
    addEventListener('scroll', stick, { passive: true });
    addEventListener('resize', render);

    render();
  }

  window.MkCompare = { add: add, remove: remove, items: function () { return items.slice(); }, url: compareUrl };
  // Footer "Compare Saunas": open the comparison with whatever the visitor already picked.
  function syncNav() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cmp-nav]'), function (a) {
      a.href = compareUrl(items.map(function (x) { return x.handle; }));
    });
  }
  document.addEventListener('mk:compare', syncNav);

  function boot() {
    syncNav();
    var page = document.getElementById('mk-cmp');
    if (page) initPage(page);
    syncToggles(); renderTray();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  addEventListener('pageshow', function (e) { if (e.persisted) { items = load(); syncToggles(); renderTray(); } });
})();
